<div class="carousel-wrapper" [attr.id]="id()">
  <button
    [attr.id]="id() ? id() + '-prev-btn' : null"
    class="nav-btn prev"
    buttonStyle="flat"
    (click)="scroll('left')"
    [disabled]="isStart()">
    <app-icon name="chevron_down" [size]="32" [color]="prevIconColor()"></app-icon>
  </button>

  <div class="scroll-viewport hidden-scrollbar" #scrollContainer>
    @for (item of items(); track trackByIndex($index, item)) {
      <div
        [attr.id]="id() ? id() + '-item-' + $index : null"
        class="carousel-item-wrapper"
        [style.width]="itemWidth()">
        <ng-container
          [ngTemplateOutlet]="itemTemplate() || defaultTemplate"
          [ngTemplateOutletContext]="{ $implicit: item }"
        >
        </ng-container>
      </div>
    }
  </div>

  <button
    [attr.id]="id() ? id() + '-next-btn' : null"
    class="nav-btn next"
    buttonStyle="flat"
    (click)="scroll('right')"
    [disabled]="isEnd()">
    <app-icon name="chevron_down" [size]="32" [color]="nextIconColor()"></app-icon>
  </button>
</div>

<ng-template #defaultTemplate let-item>{{ item | json }}</ng-template>
